import React from "react";
import classNames from "classnames";
import style from "./ShowMoreButton.module.scss";
import PropTypes from "prop-types";

const ShowMoreButton = ({isCollapsed, onClick}) => {
  return (
    <div role='button'
         onClick={onClick}
         className={classNames(style.isCollapsedButton, 'semibold')}>{isCollapsed ? 'Show More' : 'Show Less'}
      <span className={classNames(style.isCollapsedIcon, {
        'tg-icons-ChevronDown': isCollapsed,
        'tg-icons-ChevronUp': !isCollapsed
      }, 'text-sm')}>
            </span></div>
  )
}

ShowMoreButton.propTypes = {
  isCollapsed: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default ShowMoreButton;